module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"step":"Steg","notMember":"Teams er i beta. Kontakt Memolife for å bli med i testen.","loading":"Laster..."},"en":{"step":"Step","notMember":"Teams are in beta. Contact Memolife to get started with your team.","loading":"Loading..."}}')
  delete Component.options._Ctor
}
